import { render, staticRenderFns } from "./Monthly.vue?vue&type=template&id=224532f8&"
import script from "./Monthly.vue?vue&type=script&lang=js&"
export * from "./Monthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports